import { CONTENT_STORAGE_URL } from '../../constants';
import { Voice } from '../Voice';
import { VoiceDto } from '../VoiceDto';

export const voiceDtoToVoice = (
	{ id, name, img, snd }: VoiceDto,
	price?: number,
): Voice => ({
	id,
	name,
	price: price ?? 0,
	imageUrl: new URL(img, CONTENT_STORAGE_URL).toString(),
	previewUrl: new URL(snd, CONTENT_STORAGE_URL).toString(),
});
